<template>
  <aside
    v-show="$utils.showAsideNavigationMenu"
    class="o-edition-section-navigation"
  >
    <MoleculeEditionSectionNavigationMenu
      :contenido="contenido"
      :element="element"
      :show-loading-state="showLoadingState"
    />
  </aside>
</template>

<script>
export default {
  name: 'OrganismEditionSectionNavigation',

  props: {
    contenido: String,
    element: Object,
    showLoadingState: Number
  },

  components: {
    MoleculeEditionSectionNavigationMenu: () => import('@/components/molecules/MoleculeEditionSectionNavigationMenu')
  }
}
</script>
